module.exports = __webpack_public_path__ + "305831c239547bcf4e8cce149edc082f.svg";